import { createApp } from 'vue';
import TrioAssets from 'trio-assets-js';
import { router } from './js/router';

// stylings
import './scss/app.scss';

// scripts
// elements
import './js/elements/accordion';
import './js/elements/demoBenefits';
import './js/elements/onScroll';
import './js/elements/productMatrix';
import './js/elements/scrollToElement';
import './js/elements/scrollToTop';
import './js/elements/tabs';
// navigation
import './js/navigation/account-links';
import './js/navigation/mainMenu';
// paragraphs

// shared JS
import './shared';

// Vue components.
import TestimonialSlider from './js/components/TestimonialSlider';
import Dashboard from './js/components/dashboard/Dashboard';

(() => {
  TrioAssets.parallax();
})();

// PT Testimonial slider.
if (document.querySelectorAll('.testimonials').length > 0) {
  document.querySelectorAll('.testimonials').forEach((paragraph) => {
    const testimonialsApp = createApp({
      data() {
        return {};
      },
    });

    // Note: we can register components in camel case but due to caveats of
    // in-DOM template parsing, kebab case should be used in Twig markup.
    // See https://vuejs.org/guide/essentials/component-basics.html#in-dom-template-parsing-caveats.
    testimonialsApp.component('TestimonialSlider', TestimonialSlider);
    testimonialsApp.mount(paragraph);
  });
}

// Dashboard.
if (document.querySelector('#dashboard')) {
  const dashboardApp = createApp({
    data() {
      return {};
    },
  });
  dashboardApp.component('Dashboard', Dashboard);

  // Dashboard app also makes use of vue-router.
  dashboardApp.use(router).mount('#dashboard');
}



